import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IdentityProviderGuard } from './guards/identity-provider-guard.service';

const routes: Routes = [
  {
    path: '',
    canActivate: [IdentityProviderGuard],
    loadChildren: () => import('@modules/authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'form',
    loadChildren: () => import('@modules/funnel-form/form/form.module').then((m) => m.FormModule),
  },
  {
    path: 'panel',
    loadChildren: () => import('@modules/panel/panel.module').then((m) => m.PanelModule),
  },
  {
    path: 'bot',
    loadChildren: () => import('@modules/smart-menu/smart-menu.module').then((m) => m.SmartMenuModule),
  },
  {
    path: 'external-chat',
    loadChildren: () =>
      import('@components/common/external-chat-loader/external-chat-loader.module').then(
        (m) => m.ExternalChatLoaderModule
      ),
  },
  {
    path: 'panel',
    redirectTo: '/panel',
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'cross-login',
    loadChildren: () => import('@modules/cross-login/cross-login.module').then((m) => m.CrossLoginModule),
  },
  {
    path: 'login-customer/:customerId',
    loadChildren: () => import('@modules/authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'login-identity-provider/:code',
    loadChildren: () => import('@modules/authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'dialog360',
    loadChildren: () => import('@modules/dialog360/dialog360.module').then((m) => m.Dialog360Module),
  },
  {
    path: 'sso/moderna',
    loadChildren: () => import('@modules/sso-moderna/sso-moderna.module').then((m) => m.SsoModernaModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
